import { ICellRendererComp, ICellRendererParams } from "ag-grid-community";

interface IProps extends ICellRendererParams {
    //
}

class MutedCell implements ICellRendererComp {
    declare eGui: HTMLElement;
    declare eValue: HTMLElement;

    private renderValue() {
        this.eValue.innerText = "";
    }

    private buildBaseElement() {
        // create the cell
        this.eGui = document.createElement("div");
        this.eGui.innerHTML = '<div class="value"></div>';

        // get references to the elements we want
        this.eValue = this.eGui.querySelector(".value");
    }

    refresh(_params: IProps): boolean {
        // set value into cell again
        this.renderValue();

        // return true to tell the grid we refreshed successfully
        return true;
    }
    getGui(): HTMLElement {
        return this.eGui;
    }
    destroy(): void {
        // No-op
    }
    init(_params: IProps) {
        // console.log(params);
        this.buildBaseElement();

        // set value into cell
        this.renderValue();
    }
}

export { MutedCell };
